// extracted by mini-css-extract-plugin
module.exports = {"profile_image":"assignment_item_comment-module__profile_image___3jFhw"};